import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import * as yup from 'yup';

import { sendTravelToApprove } from 'actions/adminTool';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useToast from 'hooks/useToast';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Wrapper, FormContainer, Field } from './styles';

const AdminToolSendTravelToApprove = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);

      const result = await sendTravelToApprove(values.travelItineraryId);
      
      if (result.data.succeeded) {
        toast.add({ type: 'success', message: t('adminTool.sendTravelToApproveForm.toastSuccess') });
      } else {
        const errorCode = result.data?.errors?.[0];
        let errorMsg: string;

        if (errorCode === 'ItineraryExpiredCannotReturnToApproval') {
          errorMsg = t('adminTool.sendTravelToApproveForm.errorItineraryExpired', { id: values.travelItineraryId });
        } else if (errorCode === 'ItineraryCancelledCannotReturnToApproval') {
          errorMsg = t('adminTool.sendTravelToApproveForm.errorItineraryCancelled', { id: values.travelItineraryId });
        } else if (errorCode === 'ItineraryAllreadyConfirmed') {
          errorMsg = t('adminTool.sendTravelToApproveForm.errorItineraryAlreadyConfirmed', { id: values.travelItineraryId });
        } else {
          errorMsg = errorCode ?? t('adminTool.sendTravelToApproveForm.toastError');
        }

        toast.add({ type: 'danger', message: errorMsg });
      }
    } catch (error: any) {
      let errorMessage = 'An unexpected error occurred.';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      if (error?.response?.data?.error) {
        errorMessage += ` - ${error.response.data.error}`;
      }

      toast.add({ type: 'danger', message: errorMessage });
    }

    setIsLoading(false);
  };

  const validationSchema = yup.object().shape({
    travelItineraryId: yup.string().required(),
  });

  const initValues = {
    travelItineraryId: '',
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/admintool')}>
            {t('adminTool.sendTravelToApproveForm.title')}
          </Header>
        </Mobile>

        <Desktop>
          <ScreenHeader
            title={t('adminTool.sendTravelToApproveForm.title')}
            subtitle={t('adminTool.sendTravelToApproveForm.subtitle')}
          />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values, setFieldValue }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer marginBottom={dirty}>
                  <Section title={t('adminTool.sendTravelToApproveForm.parameters')} joinContent={true}>
                    <Field name="travelItineraryId" label={t('adminTool.sendTravelToApproveForm.itineraryId')}>
                      <Input placeholder="" />
                    </Field>

                    <br />
                    <br />
                  </Section>
                  <SubmitButton dirty={true} isEdit loading={isLoading}>
                    {t('adminTool.sendTravelToApproveForm.button')}
                  </SubmitButton>
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default AdminToolSendTravelToApprove;
